// @ts-nocheck
import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

interface Props extends IconProps {
  pathFill?: string;
  color?: string;
}

export const LockIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 10 12" w="10px" h="12px" {...otherProps}>
    <path
      fill={pathFill || "#231F20"}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.49961 5.4V4C1.49961 3.07174 1.86836 2.1815 2.52474 1.52513C3.18111 0.868749 4.07135 0.5 4.99961 0.5C5.92787 0.5 6.81811 0.868749 7.47448 1.52513C8.13086 2.1815 8.49961 3.07174 8.49961 4V5.4C8.87091 5.4 9.22701 5.5475 9.48956 5.81005C9.75211 6.0726 9.89961 6.4287 9.89961 6.8V10.3C9.89961 10.6713 9.75211 11.0274 9.48956 11.2899C9.22701 11.5525 8.87091 11.7 8.49961 11.7H1.49961C1.12831 11.7 0.772211 11.5525 0.50966 11.2899C0.247109 11.0274 0.0996094 10.6713 0.0996094 10.3V6.8C0.0996094 6.4287 0.247109 6.0726 0.50966 5.81005C0.772211 5.5475 1.12831 5.4 1.49961 5.4ZM7.09961 4V5.4H2.89961V4C2.89961 3.44305 3.12086 2.9089 3.51469 2.51508C3.90851 2.12125 4.44265 1.9 4.99961 1.9C5.55656 1.9 6.09071 2.12125 6.48453 2.51508C6.87836 2.9089 7.09961 3.44305 7.09961 4Z"
    />
  </Icon>
);

export const BellIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" {...otherProps}>
    <path
      d="M6.99995 1.40002C5.88604 1.40002 4.81775 1.84252 4.0301 2.63018C3.24245 3.41783 2.79995 4.48612 2.79995 5.60002V8.11022L2.30505 8.60512C2.20718 8.70302 2.14054 8.82774 2.11354 8.9635C2.08654 9.09927 2.1004 9.23999 2.15337 9.36788C2.20634 9.49577 2.29604 9.60509 2.41113 9.68201C2.52621 9.75892 2.66152 9.79999 2.79995 9.80002H11.1999C11.3384 9.79999 11.4737 9.75892 11.5888 9.68201C11.7039 9.60509 11.7936 9.49577 11.8465 9.36788C11.8995 9.23999 11.9134 9.09927 11.8864 8.9635C11.8594 8.82774 11.7927 8.70302 11.6948 8.60512L11.1999 8.11022V5.60002C11.1999 4.48612 10.7575 3.41783 9.9698 2.63018C9.18214 1.84252 8.11386 1.40002 6.99995 1.40002ZM6.99995 12.6C6.44299 12.6 5.90885 12.3788 5.51502 11.9849C5.1212 11.5911 4.89995 11.057 4.89995 10.5H9.09995C9.09995 11.057 8.8787 11.5911 8.48487 11.9849C8.09105 12.3788 7.5569 12.6 6.99995 12.6Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const ThoughtIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5999 6.99998C12.5999 9.70618 10.0925 11.9 6.9999 11.9C6.00594 11.9041 5.02559 11.6688 4.1418 11.214L1.3999 11.9L2.3365 9.71388C1.745 8.93688 1.3999 8.00378 1.3999 6.99998C1.3999 4.29378 3.9073 2.09998 6.9999 2.09998C10.0925 2.09998 12.5999 4.29378 12.5999 6.99998ZM4.8999 6.29998H3.4999V7.69998H4.8999V6.29998ZM10.4999 6.29998H9.0999V7.69998H10.4999V6.29998ZM6.2999 6.29998H7.6999V7.69998H6.2999V6.29998Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const MailIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" {...otherProps}>
    <path
      d="M1 4.11885L6.5979 6.91745L12.1958 4.11885C12.1751 3.76216 12.0188 3.42689 11.7589 3.18171C11.499 2.93652 11.1552 2.79998 10.7979 2.80005H2.3979C2.04061 2.79998 1.69681 2.93652 1.43692 3.18171C1.17704 3.42689 1.02072 3.76216 1 4.11885Z"
      fill={pathFill || "white"}
    />
    <path
      d="M12.2 5.68262L6.6 8.48262L1 5.68262V9.80002C1 10.1713 1.1475 10.5274 1.41005 10.79C1.6726 11.0525 2.0287 11.2 2.4 11.2H10.8C11.1713 11.2 11.5274 11.0525 11.7899 10.79C12.0525 10.5274 12.2 10.1713 12.2 9.80002V5.68262Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const PersonIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="20px" h="20px" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0001 6.29998C7.55705 6.29998 8.0912 6.07873 8.48502 5.6849C8.87885 5.29107 9.1001 4.75693 9.1001 4.19998C9.1001 3.64302 8.87885 3.10888 8.48502 2.71505C8.0912 2.32122 7.55705 2.09998 7.0001 2.09998C6.44314 2.09998 5.909 2.32122 5.51517 2.71505C5.12135 3.10888 4.9001 3.64302 4.9001 4.19998C4.9001 4.75693 5.12135 5.29107 5.51517 5.6849C5.909 6.07873 6.44314 6.29997 7.0001 6.29998ZM2.1001 12.6C2.1001 11.9565 2.22684 11.3193 2.47309 10.7248C2.71934 10.1303 3.08027 9.59016 3.53527 9.13515C3.99028 8.68014 4.53045 8.31921 5.12495 8.07297C5.71944 7.82672 6.35662 7.69998 7.0001 7.69998C7.64357 7.69998 8.28075 7.82672 8.87525 8.07297C9.46974 8.31921 10.0099 8.68014 10.4649 9.13515C10.9199 9.59016 11.2809 10.1303 11.5271 10.7248C11.7734 11.3193 11.9001 11.9565 11.9001 12.6H2.1001Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const HomeIcon = (props: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" {...props}>
    <path
      d="M6.42435 1.37575C6.31183 1.26326 6.15925 1.20007 6.00015 1.20007C5.84105 1.20007 5.68846 1.26326 5.57595 1.37575L1.37595 5.57575C1.26665 5.68891 1.20618 5.84047 1.20754 5.99779C1.20891 6.1551 1.27201 6.30559 1.38326 6.41684C1.4945 6.52808 1.64499 6.59118 1.80231 6.59255C1.95962 6.59392 2.11119 6.53344 2.22435 6.42415L2.40015 6.24834V10.1999C2.40015 10.3591 2.46336 10.5117 2.57588 10.6242C2.6884 10.7367 2.84102 10.7999 3.00015 10.7999H4.20015C4.35928 10.7999 4.51189 10.7367 4.62441 10.6242C4.73693 10.5117 4.80015 10.3591 4.80015 10.1999V8.99995C4.80015 8.84082 4.86336 8.6882 4.97588 8.57568C5.0884 8.46316 5.24102 8.39995 5.40015 8.39995H6.60015C6.75928 8.39995 6.91189 8.46316 7.02441 8.57568C7.13693 8.6882 7.20015 8.84082 7.20015 8.99995V10.1999C7.20015 10.3591 7.26336 10.5117 7.37588 10.6242C7.4884 10.7367 7.64102 10.7999 7.80015 10.7999H9.00015C9.15928 10.7999 9.31189 10.7367 9.42441 10.6242C9.53693 10.5117 9.60015 10.3591 9.60015 10.1999V6.24834L9.77595 6.42415C9.88911 6.53344 10.0407 6.59392 10.198 6.59255C10.3553 6.59118 10.5058 6.52808 10.617 6.41684C10.7283 6.30559 10.7914 6.1551 10.7928 5.99779C10.7941 5.84047 10.7336 5.68891 10.6243 5.57575L6.42435 1.37575Z"
      fill="black"
    />
  </Icon>
);

export const PrintIcon = (props: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1 1.4V3.5H1.4C1.0287 3.5 0.672601 3.6475 0.41005 3.91005C0.1475 4.1726 0 4.5287 0 4.9V7C0 7.3713 0.1475 7.7274 0.41005 7.98995C0.672601 8.2525 1.0287 8.4 1.4 8.4H2.1V9.8C2.1 10.1713 2.2475 10.5274 2.51005 10.7899C2.7726 11.0525 3.1287 11.2 3.5 11.2H7.7C8.0713 11.2 8.4274 11.0525 8.68995 10.7899C8.9525 10.5274 9.1 10.1713 9.1 9.8V8.4H9.8C10.1713 8.4 10.5274 8.2525 10.7899 7.98995C11.0525 7.7274 11.2 7.3713 11.2 7V4.9C11.2 4.5287 11.0525 4.1726 10.7899 3.91005C10.5274 3.6475 10.1713 3.5 9.8 3.5H9.1V1.4C9.1 1.0287 8.9525 0.672601 8.68995 0.41005C8.4274 0.1475 8.0713 0 7.7 0H3.5C3.1287 0 2.7726 0.1475 2.51005 0.41005C2.2475 0.672601 2.1 1.0287 2.1 1.4ZM7.7 1.4H3.5V3.5H7.7V1.4ZM7.7 7H3.5V9.8H7.7V7Z"
      fill="black"
      fillOpacity="0.59"
    />
  </Icon>
);

export const DialogueIcon = (props: Props) => (
  <Icon viewBox="0 0 12 11" w="12px" h="11px" {...props}>
    <path
      d="M0 1.4C0 1.0287 0.1475 0.672601 0.41005 0.41005C0.672601 0.1475 1.0287 0 1.4 0H6.3C6.6713 0 7.0274 0.1475 7.28995 0.41005C7.5525 0.672601 7.7 1.0287 7.7 1.4V4.2C7.7 4.5713 7.5525 4.9274 7.28995 5.18995C7.0274 5.4525 6.6713 5.6 6.3 5.6H4.9L2.8 7.7V5.6H1.4C1.0287 5.6 0.672601 5.4525 0.41005 5.18995C0.1475 4.9274 0 4.5713 0 4.2V1.4Z"
      fill="black"
      fillOpacity="0.59"
    />
    <path
      d="M9.10025 2.80005V4.20005C9.10025 4.94265 8.80525 5.65485 8.28015 6.17995C7.75505 6.70505 7.04286 7.00005 6.30025 7.00005H5.47985L4.24365 8.23695C4.43965 8.34125 4.66295 8.40005 4.90025 8.40005H6.30025L8.40025 10.5V8.40005H9.80025C10.1716 8.40005 10.5277 8.25255 10.7902 7.99C11.0528 7.72745 11.2003 7.37135 11.2003 7.00005V4.20005C11.2003 3.82875 11.0528 3.47265 10.7902 3.2101C10.5277 2.94755 10.1716 2.80005 9.80025 2.80005H9.10025Z"
      fill="black"
      fillOpacity="0.59"
    />
  </Icon>
);

export const QuestionIcon = (props: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2 5.6C11.2 7.08521 10.61 8.50959 9.5598 9.5598C8.50959 10.61 7.08521 11.2 5.6 11.2C4.11479 11.2 2.69041 10.61 1.6402 9.5598C0.589998 8.50959 0 7.08521 0 5.6C0 4.11479 0.589998 2.69041 1.6402 1.6402C2.69041 0.589998 4.11479 0 5.6 0C7.08521 0 8.50959 0.589998 9.5598 1.6402C10.61 2.69041 11.2 4.11479 11.2 5.6ZM5.6 3.5C5.47701 3.49988 5.35616 3.53217 5.24961 3.59361C5.14307 3.65506 5.0546 3.74349 4.9931 3.85C4.9487 3.93251 4.88818 4.00527 4.81513 4.06396C4.74209 4.12265 4.658 4.16608 4.56786 4.19167C4.47772 4.21726 4.38336 4.22449 4.29037 4.21294C4.19739 4.20139 4.10767 4.17128 4.02653 4.12441C3.94539 4.07754 3.87449 4.01485 3.81803 3.94007C3.76157 3.86529 3.7207 3.77993 3.69784 3.68906C3.67498 3.59819 3.6706 3.50365 3.68495 3.41105C3.6993 3.31846 3.7321 3.22969 3.7814 3.15C4.01255 2.74968 4.36934 2.43681 4.79642 2.25992C5.2235 2.08303 5.69701 2.05201 6.14353 2.17165C6.59004 2.29129 6.9846 2.55493 7.26602 2.92166C7.54743 3.28839 7.69998 3.73774 7.7 4.2C7.70013 4.63443 7.56556 5.05822 7.31483 5.413C7.06411 5.76777 6.70955 6.03609 6.3 6.181V6.3C6.3 6.48565 6.22625 6.6637 6.09497 6.79497C5.9637 6.92625 5.78565 7 5.6 7C5.41435 7 5.2363 6.92625 5.10503 6.79497C4.97375 6.6637 4.9 6.48565 4.9 6.3V5.6C4.9 5.41435 4.97375 5.2363 5.10503 5.10503C5.2363 4.97375 5.41435 4.9 5.6 4.9C5.78565 4.9 5.9637 4.82625 6.09497 4.69497C6.22625 4.5637 6.3 4.38565 6.3 4.2C6.3 4.01435 6.22625 3.8363 6.09497 3.70503C5.9637 3.57375 5.78565 3.5 5.6 3.5ZM5.6 9.1C5.78565 9.1 5.9637 9.02625 6.09497 8.89497C6.22625 8.7637 6.3 8.58565 6.3 8.4C6.3 8.21435 6.22625 8.0363 6.09497 7.90503C5.9637 7.77375 5.78565 7.7 5.6 7.7C5.41435 7.7 5.2363 7.77375 5.10503 7.90503C4.97375 8.0363 4.9 8.21435 4.9 8.4C4.9 8.58565 4.97375 8.7637 5.10503 8.89497C5.2363 9.02625 5.41435 9.1 5.6 9.1Z"
      fill="black"
      fillOpacity="0.59"
    />
  </Icon>
);

export const ArrowRightIcon = (props: Props) => (
  <Icon viewBox="0 0 16 17" w="16px" h="17px" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.37827 15.1571 4.34344 13.6569 2.84315C12.1566 1.34285 10.1217 0.5 8 0.5C5.87827 0.5 3.84344 1.34285 2.34315 2.84315C0.842855 4.34344 0 6.37827 0 8.5C0 10.6217 0.842855 12.6566 2.34315 14.1569C3.84344 15.6571 5.87827 16.5 8 16.5ZM11.707 7.793L8.707 4.793C8.5184 4.61084 8.2658 4.51005 8.0036 4.51233C7.7414 4.5146 7.49059 4.61977 7.30518 4.80518C7.11977 4.99059 7.0146 5.2414 7.01233 5.5036C7.01005 5.7658 7.11084 6.0184 7.293 6.207L8.586 7.5H5C4.73478 7.5 4.48043 7.60536 4.29289 7.79289C4.10536 7.98043 4 8.23478 4 8.5C4 8.76522 4.10536 9.01957 4.29289 9.20711C4.48043 9.39464 4.73478 9.5 5 9.5H8.586L7.293 10.793C7.19749 10.8852 7.12131 10.9956 7.0689 11.1176C7.01649 11.2396 6.9889 11.3708 6.98775 11.5036C6.9866 11.6364 7.0119 11.7681 7.06218 11.891C7.11246 12.0139 7.18671 12.1255 7.28061 12.2194C7.3745 12.3133 7.48615 12.3875 7.60905 12.4378C7.73194 12.4881 7.86362 12.5134 7.9964 12.5123C8.12918 12.5111 8.2604 12.4835 8.3824 12.4311C8.50441 12.3787 8.61475 12.3025 8.707 12.207L11.707 9.207C11.8945 9.01947 11.9998 8.76516 11.9998 8.5C11.9998 8.23484 11.8945 7.98053 11.707 7.793Z"
      fill="#FFCC00"
    />
  </Icon>
);

export const FeedbackIcon = (props: IconProps) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" fill="none" {...props}>
    <path
      d="M0 1.4C0 1.0287 0.1475 0.672601 0.41005 0.41005C0.672601 0.1475 1.0287 0 1.4 0H6.3C6.6713 0 7.0274 0.1475 7.28995 0.41005C7.5525 0.672601 7.7 1.0287 7.7 1.4V4.2C7.7 4.5713 7.5525 4.9274 7.28995 5.18995C7.0274 5.4525 6.6713 5.6 6.3 5.6H4.9L2.8 7.7V5.6H1.4C1.0287 5.6 0.672601 5.4525 0.41005 5.18995C0.1475 4.9274 0 4.5713 0 4.2V1.4Z"
      fill="black"
      fill-opacity="0.59"
    />
    <path
      d="M9.10025 2.80005V4.20005C9.10025 4.94265 8.80525 5.65485 8.28015 6.17995C7.75505 6.70505 7.04286 7.00005 6.30025 7.00005H5.47985L4.24365 8.23695C4.43965 8.34125 4.66295 8.40005 4.90025 8.40005H6.30025L8.40025 10.5V8.40005H9.80025C10.1716 8.40005 10.5277 8.25255 10.7902 7.99C11.0528 7.72745 11.2003 7.37135 11.2003 7.00005V4.20005C11.2003 3.82875 11.0528 3.47265 10.7902 3.2101C10.5277 2.94755 10.1716 2.80005 9.80025 2.80005H9.10025Z"
      fill="black"
      fill-opacity="0.59"
    />
  </Icon>
);

export const ArrowLeftIcon = (props: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.6 11.6C7.08521 11.6 8.50959 11.01 9.5598 9.95982C10.61 8.90962 11.2 7.48524 11.2 6.00002C11.2 4.51481 10.61 3.09043 9.5598 2.04023C8.50959 0.990023 7.08521 0.400024 5.6 0.400024C4.11479 0.400024 2.69041 0.990023 1.6402 2.04023C0.589998 3.09043 0 4.51481 0 6.00002C0 7.48524 0.589998 8.90962 1.6402 9.95982C2.69041 11.01 4.11479 11.6 5.6 11.6ZM6.0949 4.39492C6.22241 4.2629 6.29297 4.08608 6.29137 3.90254C6.28978 3.71901 6.21616 3.54344 6.08637 3.41365C5.95659 3.28387 5.78102 3.21025 5.59748 3.20865C5.41394 3.20706 5.23712 3.27761 5.1051 3.40512L3.0051 5.50512C2.87387 5.63639 2.80015 5.81441 2.80015 6.00002C2.80015 6.18564 2.87387 6.36365 3.0051 6.49492L5.1051 8.59492C5.23712 8.72243 5.41394 8.79299 5.59748 8.7914C5.78102 8.7898 5.95659 8.71618 6.08637 8.5864C6.21616 8.45661 6.28978 8.28104 6.29137 8.09751C6.29297 7.91397 6.22241 7.73715 6.0949 7.60512L5.1898 6.70002H7.7C7.88565 6.70002 8.0637 6.62627 8.19497 6.495C8.32625 6.36372 8.4 6.18568 8.4 6.00002C8.4 5.81437 8.32625 5.63633 8.19497 5.50505C8.0637 5.37377 7.88565 5.30002 7.7 5.30002H5.1898L6.0949 4.39492Z"
      fill="black"
    />
  </Icon>
);

export const PenIcon = (props: Props) => (
  <Icon viewBox="0 0 18 18" w="18px" h="18px" fill="none" {...props}>
    <path
      d="M12.2276 3.22738C12.3936 3.05546 12.5923 2.91833 12.8119 2.82399C13.0315 2.72966 13.2677 2.68 13.5067 2.67792C13.7457 2.67585 13.9827 2.72139 14.2039 2.8119C14.4251 2.9024 14.6261 3.03606 14.7951 3.20506C14.9641 3.37407 15.0978 3.57504 15.1883 3.79626C15.2788 4.01747 15.3243 4.25449 15.3222 4.4935C15.3202 4.7325 15.2705 4.9687 15.1762 5.1883C15.0818 5.40791 14.9447 5.60653 14.7728 5.77258L14.0591 6.48627L11.5139 3.94108L12.2276 3.22738ZM10.2413 5.21368L2.7002 12.7548V15.3H5.2454L12.7874 7.75888L10.2404 5.21368H10.2413Z"
      fill="#244065"
    />
  </Icon>
);

export const HelpIcon = (props: IconProps) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2 5.6C11.2 7.08521 10.61 8.50959 9.5598 9.5598C8.50959 10.61 7.08521 11.2 5.6 11.2C4.11479 11.2 2.69041 10.61 1.6402 9.5598C0.589998 8.50959 0 7.08521 0 5.6C0 4.11479 0.589998 2.69041 1.6402 1.6402C2.69041 0.589998 4.11479 0 5.6 0C7.08521 0 8.50959 0.589998 9.5598 1.6402C10.61 2.69041 11.2 4.11479 11.2 5.6ZM5.6 3.5C5.47701 3.49988 5.35616 3.53217 5.24961 3.59361C5.14307 3.65506 5.0546 3.74349 4.9931 3.85C4.9487 3.93251 4.88818 4.00527 4.81513 4.06396C4.74209 4.12265 4.658 4.16608 4.56786 4.19167C4.47772 4.21726 4.38336 4.22449 4.29037 4.21294C4.19739 4.20139 4.10767 4.17128 4.02653 4.12441C3.94539 4.07754 3.87449 4.01485 3.81803 3.94007C3.76157 3.86529 3.7207 3.77993 3.69784 3.68906C3.67498 3.59819 3.6706 3.50365 3.68495 3.41105C3.6993 3.31846 3.7321 3.22969 3.7814 3.15C4.01255 2.74968 4.36934 2.43681 4.79642 2.25992C5.2235 2.08303 5.69701 2.05201 6.14353 2.17165C6.59004 2.29129 6.9846 2.55493 7.26602 2.92166C7.54743 3.28839 7.69998 3.73774 7.7 4.2C7.70013 4.63443 7.56556 5.05822 7.31483 5.413C7.06411 5.76777 6.70955 6.03609 6.3 6.181V6.3C6.3 6.48565 6.22625 6.6637 6.09497 6.79497C5.9637 6.92625 5.78565 7 5.6 7C5.41435 7 5.2363 6.92625 5.10503 6.79497C4.97375 6.6637 4.9 6.48565 4.9 6.3V5.6C4.9 5.41435 4.97375 5.2363 5.10503 5.10503C5.2363 4.97375 5.41435 4.9 5.6 4.9C5.78565 4.9 5.9637 4.82625 6.09497 4.69497C6.22625 4.5637 6.3 4.38565 6.3 4.2C6.3 4.01435 6.22625 3.8363 6.09497 3.70503C5.9637 3.57375 5.78565 3.5 5.6 3.5ZM5.6 9.1C5.78565 9.1 5.9637 9.02625 6.09497 8.89497C6.22625 8.7637 6.3 8.58565 6.3 8.4C6.3 8.21435 6.22625 8.0363 6.09497 7.90503C5.9637 7.77375 5.78565 7.7 5.6 7.7C5.41435 7.7 5.2363 7.77375 5.10503 7.90503C4.97375 8.0363 4.9 8.21435 4.9 8.4C4.9 8.58565 4.97375 8.7637 5.10503 8.89497C5.2363 9.02625 5.41435 9.1 5.6 9.1Z"
      fill="black"
      fillOpacity="0.59"
    />
  </Icon>
);
export const PaperPlaneIcon = (props: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" fill="none" {...props}>
    <path
      d="M12.8332 1.16669L6.4165 7.58335"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8332 1.16669L8.74984 12.8334L6.4165 7.58335L1.1665 5.25002L12.8332 1.16669Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GlobeIcon = (props: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" fill="none" {...props}>
    <path
      d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00002C12.8337 3.77836 10.222 1.16669 7.00033 1.16669C3.77866 1.16669 1.16699 3.77836 1.16699 7.00002C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.16699 7H12.8337"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.00033 1.16669C8.45941 2.76406 9.2886 4.83704 9.33366 7.00002C9.2886 9.163 8.45941 11.236 7.00033 12.8334C5.54125 11.236 4.71205 9.163 4.66699 7.00002C4.71205 4.83704 5.54125 2.76406 7.00033 1.16669V1.16669Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FileIcon = (props: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" fill="none" {...props}>
    <path
      d="M8.16634 1.16669H3.49967C3.19026 1.16669 2.89351 1.2896 2.67472 1.5084C2.45592 1.72719 2.33301 2.02393 2.33301 2.33335V11.6667C2.33301 11.9761 2.45592 12.2729 2.67472 12.4916C2.89351 12.7104 3.19026 12.8334 3.49967 12.8334H10.4997C10.8091 12.8334 11.1058 12.7104 11.3246 12.4916C11.5434 12.2729 11.6663 11.9761 11.6663 11.6667V4.66669L8.16634 1.16669Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16699 1.16669V4.66669H11.667"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33366 7.58331H4.66699"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33366 9.91669H4.66699"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83366 5.25H5.25033H4.66699"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChevronRightIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" fill="none" {...otherProps}>
    <path
      d="M4.5 2.5L8 6L4.5 9.5"
      stroke={pathFill || "#1175B5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChevronLeftIcon = (props: Props) => (
  <Icon viewBox="0 0 10 16" w="10px" h="16px" fill="none" {...props}>
    <path
      d="M7.33349 0H8.66683C8.92416 0 9.15882 0.148667 9.26949 0.381333C9.38016 0.614 9.34616 0.889333 9.18283 1.08933L3.52816 8L9.18283 14.9113C9.34616 15.1107 9.37949 15.386 9.26949 15.6193C9.15949 15.8527 8.92416 16 8.66683 16H7.33349C7.13349 16 6.94416 15.91 6.81749 15.7553L0.817492 8.422C0.616826 8.176 0.616826 7.82333 0.817492 7.57733L6.81749 0.244C6.94416 0.09 7.13349 0 7.33349 0Z"
      fill="black"
    />
  </Icon>
);

export const DownloadIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" fill="none" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1001 11.9C2.1001 11.7144 2.17385 11.5363 2.30512 11.405C2.4364 11.2738 2.61445 11.2 2.8001 11.2H11.2001C11.3857 11.2 11.5638 11.2738 11.6951 11.405C11.8263 11.5363 11.9001 11.7144 11.9001 11.9C11.9001 12.0857 11.8263 12.2637 11.6951 12.395C11.5638 12.5263 11.3857 12.6 11.2001 12.6H2.8001C2.61445 12.6 2.4364 12.5263 2.30512 12.395C2.17385 12.2637 2.1001 12.0857 2.1001 11.9ZM4.4052 6.50512C4.53647 6.37389 4.71448 6.30017 4.9001 6.30017C5.08571 6.30017 5.26373 6.37389 5.395 6.50512L6.3001 7.41022V2.10002C6.3001 1.91437 6.37385 1.73633 6.50512 1.60505C6.6364 1.47377 6.81445 1.40002 7.0001 1.40002C7.18575 1.40002 7.3638 1.47377 7.49507 1.60505C7.62635 1.73633 7.7001 1.91437 7.7001 2.10002V7.41022L8.6052 6.50512C8.66977 6.43827 8.74701 6.38494 8.83241 6.34825C8.91782 6.31157 9.00967 6.29226 9.10262 6.29145C9.19556 6.29064 9.28774 6.30835 9.37377 6.34355C9.45979 6.37875 9.53795 6.43072 9.60367 6.49645C9.6694 6.56217 9.72138 6.64033 9.75657 6.72636C9.79177 6.81238 9.80948 6.90456 9.80867 6.9975C9.80787 7.09045 9.78856 7.1823 9.75187 7.26771C9.71518 7.35311 9.66185 7.43035 9.595 7.49492L7.495 9.59492C7.36373 9.72615 7.18571 9.79987 7.0001 9.79987C6.81448 9.79987 6.63647 9.72615 6.5052 9.59492L4.4052 7.49492C4.27397 7.36365 4.20025 7.18564 4.20025 7.00002C4.20025 6.81441 4.27397 6.63639 4.4052 6.50512Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const MagnifyingGlassIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 14 14" w="14px" h="14px" fill="none" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5999 2.80001C4.8573 2.80001 4.14511 3.09501 3.62 3.62011C3.0949 4.14521 2.7999 4.85741 2.7999 5.60001C2.7999 6.34262 3.0949 7.05481 3.62 7.57991C4.14511 8.10501 4.8573 8.40001 5.5999 8.40001C6.34251 8.40001 7.0547 8.10501 7.5798 7.57991C8.1049 7.05481 8.3999 6.34262 8.3999 5.60001C8.3999 4.85741 8.1049 4.14521 7.5798 3.62011C7.0547 3.09501 6.34251 2.80001 5.5999 2.80001ZM1.3999 5.60001C1.39982 4.939 1.55575 4.28731 1.85502 3.69793C2.15429 3.10855 2.58845 2.59813 3.12218 2.20818C3.65591 1.81823 4.27415 1.55976 4.9266 1.45379C5.57906 1.34783 6.24732 1.39736 6.87703 1.59836C7.50673 1.79935 8.08011 2.14614 8.55052 2.61052C9.02093 3.07489 9.37509 3.64374 9.5842 4.2708C9.79331 4.89786 9.85146 5.56543 9.75393 6.2192C9.6564 6.87297 9.40593 7.49449 9.0229 8.03321L12.3948 11.4051C12.5223 11.5371 12.5929 11.714 12.5913 11.8975C12.5897 12.081 12.5161 12.2566 12.3863 12.3864C12.2565 12.5162 12.0809 12.5898 11.8974 12.5914C11.7138 12.593 11.537 12.5224 11.405 12.3949L8.0338 9.02371C7.40546 9.47051 6.66625 9.73572 5.89718 9.79029C5.12811 9.84487 4.35885 9.68669 3.67371 9.33309C2.98857 8.9795 2.41398 8.44413 2.01291 7.78566C1.61183 7.12718 1.39975 6.37102 1.3999 5.60001Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const PrinterIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 12 12" w="12px" h="12px" fill="none" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1 1.4V3.5H1.4C1.0287 3.5 0.672601 3.6475 0.41005 3.91005C0.1475 4.1726 0 4.5287 0 4.9V7C0 7.3713 0.1475 7.7274 0.41005 7.98995C0.672601 8.2525 1.0287 8.4 1.4 8.4H2.1V9.8C2.1 10.1713 2.2475 10.5274 2.51005 10.7899C2.7726 11.0525 3.1287 11.2 3.5 11.2H7.7C8.0713 11.2 8.4274 11.0525 8.68995 10.7899C8.9525 10.5274 9.1 10.1713 9.1 9.8V8.4H9.8C10.1713 8.4 10.5274 8.2525 10.7899 7.98995C11.0525 7.7274 11.2 7.3713 11.2 7V4.9C11.2 4.5287 11.0525 4.1726 10.7899 3.91005C10.5274 3.6475 10.1713 3.5 9.8 3.5H9.1V1.4C9.1 1.0287 8.9525 0.672601 8.68995 0.41005C8.4274 0.1475 8.0713 0 7.7 0H3.5C3.1287 0 2.7726 0.1475 2.51005 0.41005C2.2475 0.672601 2.1 1.0287 2.1 1.4ZM7.7 1.4H3.5V3.5H7.7V1.4ZM7.7 7H3.5V9.8H7.7V7Z"
      fill={pathFill || "white"}
    />
  </Icon>
);

export const SaveAsPdfIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon h="14" viewBox="0 0 12 14" fill="none" {...otherProps}>
    <path
      d="M5.99967 5.66667V9.66667V5.66667ZM5.99967 9.66667L3.99967 7.66667L5.99967 9.66667ZM5.99967 9.66667L7.99967 7.66667L5.99967 9.66667ZM9.33301 13H2.66634C2.31272 13 1.97358 12.8595 1.72353 12.6095C1.47348 12.3594 1.33301 12.0203 1.33301 11.6667V2.33333C1.33301 1.97971 1.47348 1.64057 1.72353 1.39052C1.97358 1.14048 2.31272 1 2.66634 1H6.39034C6.56714 1.00004 6.73668 1.0703 6.86167 1.19533L10.471 4.80467C10.596 4.92966 10.6663 5.0992 10.6663 5.276V11.6667C10.6663 12.0203 10.5259 12.3594 10.2758 12.6095C10.0258 12.8595 9.68663 13 9.33301 13Z"
      stroke="#1175B5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowRightSimpleIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon h="14px" w="7px" viewBox="0 0 7 14" fill="none" {...otherProps}>
    <path
      d="M0.499999 1L6.5 7L0.5 13"
      stroke="#231F20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InfoIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon w="10px" h="10px" viewBox="0 0 10 10" fill="none" {...otherProps}>
    <path
      d="M5.5 7H5V5H4.5L5.5 7ZM5 3H5.005H5ZM9.5 5C9.5 5.59095 9.3836 6.17611 9.15746 6.72208C8.93131 7.26804 8.59984 7.76412 8.18198 8.18198C7.76412 8.59984 7.26804 8.93131 6.72208 9.15746C6.17611 9.3836 5.59095 9.5 5 9.5C4.40905 9.5 3.82389 9.3836 3.27792 9.15746C2.73196 8.93131 2.23588 8.59984 1.81802 8.18198C1.40016 7.76412 1.06869 7.26804 0.842542 6.72208C0.616396 6.17611 0.5 5.59095 0.5 5C0.5 3.80653 0.974106 2.66193 1.81802 1.81802C2.66193 0.974106 3.80653 0.5 5 0.5C6.19347 0.5 7.33807 0.974106 8.18198 1.81802C9.02589 2.66193 9.5 3.80653 9.5 5Z"
      stroke="#1175B5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
export const BurgerMenuIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon viewBox="0 0 19 15" w="19px" h="15px" fill="none" {...otherProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 1.25C0.75 0.918479 0.881696 0.600537 1.11612 0.366117C1.35054 0.131696 1.66848 0 2 0H17C17.3315 0 17.6495 0.131696 17.8839 0.366117C18.1183 0.600537 18.25 0.918479 18.25 1.25C18.25 1.58152 18.1183 1.89946 17.8839 2.13388C17.6495 2.3683 17.3315 2.5 17 2.5H2C1.66848 2.5 1.35054 2.3683 1.11612 2.13388C0.881696 1.89946 0.75 1.58152 0.75 1.25ZM0.75 7.5C0.75 7.16848 0.881696 6.85054 1.11612 6.61612C1.35054 6.3817 1.66848 6.25 2 6.25H17C17.3315 6.25 17.6495 6.3817 17.8839 6.61612C18.1183 6.85054 18.25 7.16848 18.25 7.5C18.25 7.83152 18.1183 8.14946 17.8839 8.38388C17.6495 8.6183 17.3315 8.75 17 8.75H2C1.66848 8.75 1.35054 8.6183 1.11612 8.38388C0.881696 8.14946 0.75 7.83152 0.75 7.5ZM8.25 13.75C8.25 13.4185 8.3817 13.1005 8.61612 12.8661C8.85054 12.6317 9.16848 12.5 9.5 12.5H17C17.3315 12.5 17.6495 12.6317 17.8839 12.8661C18.1183 13.1005 18.25 13.4185 18.25 13.75C18.25 14.0815 18.1183 14.3995 17.8839 14.6339C17.6495 14.8683 17.3315 15 17 15H9.5C9.16848 15 8.85054 14.8683 8.61612 14.6339C8.3817 14.3995 8.25 14.0815 8.25 13.75Z"
      fill="white"
    />
  </Icon>
);

export const CloseIcon = ({ pathFill, ...otherProps }: Props) => (
  <Icon w="10px" h="10px" viewBox="0 0 10 10" fill="none" {...otherProps}>
    <path
      d="M0.5 0.5L9.5 9.5M0.5 9.5L9.5 0.5L0.5 9.5Z"
      stroke={pathFill || "white"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CloseOutlineIcon = (props: Props) => (
  <Icon w="21px" h="21px" viewBox="0 0 21 21" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 20.5C13.1522 20.5 15.6957 19.4464 17.5711 17.5711C19.4464 15.6957 20.5 13.1522 20.5 10.5C20.5 7.84784 19.4464 5.3043 17.5711 3.42893C15.6957 1.55357 13.1522 0.5 10.5 0.5C7.84784 0.5 5.3043 1.55357 3.42893 3.42893C1.55357 5.3043 0.5 7.84784 0.5 10.5C0.5 13.1522 1.55357 15.6957 3.42893 17.5711C5.3043 19.4464 7.84784 20.5 10.5 20.5ZM8.88375 7.11625C8.648 6.88855 8.33224 6.76256 8.0045 6.76541C7.67675 6.76826 7.36324 6.89972 7.13148 7.13148C6.89972 7.36324 6.76826 7.67675 6.76541 8.0045C6.76256 8.33224 6.88855 8.648 7.11625 8.88375L8.7325 10.5L7.11625 12.1163C6.99686 12.2316 6.90163 12.3695 6.83612 12.522C6.77061 12.6745 6.73613 12.8385 6.73469 13.0045C6.73324 13.1705 6.76487 13.3351 6.82772 13.4887C6.89057 13.6423 6.98339 13.7819 7.10076 13.8992C7.21812 14.0166 7.35769 14.1094 7.51131 14.1723C7.66493 14.2351 7.82953 14.2668 7.9955 14.2653C8.16148 14.2639 8.3255 14.2294 8.47801 14.1639C8.63051 14.0984 8.76844 14.0031 8.88375 13.8837L10.5 12.2675L12.1163 13.8837C12.352 14.1114 12.6678 14.2374 12.9955 14.2346C13.3232 14.2317 13.6368 14.1003 13.8685 13.8685C14.1003 13.6368 14.2317 13.3232 14.2346 12.9955C14.2374 12.6678 14.1114 12.352 13.8837 12.1163L12.2675 10.5L13.8837 8.88375C14.1114 8.648 14.2374 8.33224 14.2346 8.0045C14.2317 7.67675 14.1003 7.36324 13.8685 7.13148C13.6368 6.89972 13.3232 6.76826 12.9955 6.76541C12.6678 6.76256 12.352 6.88855 12.1163 7.11625L10.5 8.7325L8.88375 7.11625Z"
      fill="white"
    />
  </Icon>
);

export const DollarOutlineIcon = (props: Props) => (
  <Icon w="18px" h="20px" viewBox="0 0 18 20" fill="none" {...props}>
    <path
      d="M8.85073 6C7.33071 6 6.09873 6.895 6.09873 8C6.09873 9.105 7.33071 10 8.85073 10C10.3707 10 11.6027 10.895 11.6027 12C11.6027 13.105 10.3707 14 8.85073 14V6ZM8.85073 6C9.86897 6 10.7588 6.402 11.2349 7L8.85073 6ZM8.85073 6V5V6ZM8.85073 6V14V6ZM8.85073 14V15V14ZM8.85073 14C7.83249 14 6.94267 13.598 6.46658 13L8.85073 14ZM17.1067 10C17.1067 11.1819 16.8932 12.3522 16.4783 13.4442C16.0634 14.5361 15.4552 15.5282 14.6886 16.364C13.922 17.1997 13.0118 17.8626 12.0102 18.3149C11.0085 18.7672 9.93492 19 8.85073 19C7.76653 19 6.69296 18.7672 5.69129 18.3149C4.68963 17.8626 3.77949 17.1997 3.01285 16.364C2.24621 15.5282 1.63808 14.5361 1.22318 13.4442C0.808274 12.3522 0.594727 11.1819 0.594727 10C0.594727 7.61305 1.46455 5.32387 3.01285 3.63604C4.56115 1.94821 6.6611 1 8.85073 1C11.0404 1 13.1403 1.94821 14.6886 3.63604C16.2369 5.32387 17.1067 7.61305 17.1067 10Z"
      stroke="#B4B8BB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DollarOutlineDarkIcon = (props: Props) => (
  <Icon w="12px" h="12px" viewBox="0 0 12 12" fill="none" {...props}>
    <path
      d="M6 3.66667C5.03342 3.66667 4.25 4.18875 4.25 4.83333C4.25 5.47792 5.03342 6 6 6C6.96658 6 7.75 6.52208 7.75 7.16667C7.75 7.81125 6.96658 8.33333 6 8.33333M6 3.66667V8.33333M6 3.66667C6.6475 3.66667 7.21333 3.90117 7.51608 4.25M6 3.66667V3.08333M6 8.33333V8.91667M6 8.33333C5.3525 8.33333 4.78667 8.09883 4.48392 7.75M11.25 6C11.25 6.68944 11.1142 7.37213 10.8504 8.00909C10.5865 8.64605 10.1998 9.2248 9.71231 9.71231C9.2248 10.1998 8.64605 10.5865 8.00909 10.8504C7.37213 11.1142 6.68944 11.25 6 11.25C5.31056 11.25 4.62787 11.1142 3.99091 10.8504C3.35395 10.5865 2.7752 10.1998 2.28769 9.71231C1.80018 9.2248 1.41347 8.64605 1.14963 8.00909C0.885795 7.37213 0.75 6.68944 0.75 6C0.75 4.60761 1.30312 3.27226 2.28769 2.28769C3.27226 1.30312 4.60761 0.75 6 0.75C7.39239 0.75 8.72774 1.30312 9.71231 2.28769C10.6969 3.27226 11.25 4.60761 11.25 6Z"
      stroke="#231F20"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ColumnChartIcon = (props: Props) => (
  <Icon w="15px" h="16px" viewBox="0 0 15 16" fill="none" {...props}>
    <path
      d="M5.53913 13.25V8.75C5.53913 8.35218 5.39416 7.97064 5.13611 7.68934C4.87806 7.40804 4.52807 7.25 4.16313 7.25H2.78713C2.42219 7.25 2.0722 7.40804 1.81415 7.68934C1.5561 7.97064 1.41113 8.35218 1.41113 8.75V13.25C1.41113 13.6478 1.5561 14.0294 1.81415 14.3107C2.0722 14.592 2.42219 14.75 2.78713 14.75H4.16313C4.52807 14.75 4.87806 14.592 5.13611 14.3107C5.39416 14.0294 5.53913 13.6478 5.53913 13.25ZM5.53913 13.25V5.75C5.53913 5.35218 5.6841 4.97064 5.94215 4.68934C6.2002 4.40804 6.55019 4.25 6.91513 4.25H8.29113C8.65607 4.25 9.00606 4.40804 9.26411 4.68934C9.52216 4.97064 9.66713 5.35218 9.66713 5.75V13.25M5.53913 13.25C5.53913 13.6478 5.6841 14.0294 5.94215 14.3107C6.2002 14.592 6.55019 14.75 6.91513 14.75H8.29113C8.65607 14.75 9.00606 14.592 9.26411 14.3107C9.52216 14.0294 9.66713 13.6478 9.66713 13.25M9.66713 13.25V2.75C9.66713 2.35218 9.8121 1.97064 10.0702 1.68934C10.3282 1.40804 10.6782 1.25 11.0431 1.25H12.4191C12.7841 1.25 13.1341 1.40804 13.3921 1.68934C13.6502 1.97064 13.7951 2.35218 13.7951 2.75V13.25C13.7951 13.6478 13.6502 14.0294 13.3921 14.3107C13.1341 14.592 12.7841 14.75 12.4191 14.75H11.0431C10.6782 14.75 10.3282 14.592 10.0702 14.3107C9.8121 14.0294 9.66713 13.6478 9.66713 13.25Z"
      stroke="#1175B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EditIcon = (props: Props) => (
  <Icon w="15px" h="15px" viewBox="0 0 15 15" fill="none" {...props}>
    <path
      d="M6.25 2.74988H2.5C2.10218 2.74988 1.72064 2.90791 1.43934 3.18922C1.15804 3.47052 1 3.85205 1 4.24988V12.4999C1 12.8977 1.15804 13.2792 1.43934 13.5605C1.72064 13.8418 2.10218 13.9999 2.5 13.9999H10.75C11.1478 13.9999 11.5294 13.8418 11.8107 13.5605C12.092 13.2792 12.25 12.8977 12.25 12.4999V8.74988M11.1895 1.68938C11.3279 1.54611 11.4934 1.43184 11.6764 1.35323C11.8594 1.27461 12.0562 1.23323 12.2554 1.2315C12.4546 1.22977 12.6521 1.26772 12.8364 1.34315C13.0208 1.41857 13.1883 1.52995 13.3291 1.67079C13.4699 1.81162 13.5813 1.9791 13.6567 2.16345C13.7322 2.34779 13.7701 2.54531 13.7684 2.74448C13.7666 2.94365 13.7253 3.14048 13.6467 3.32348C13.568 3.50649 13.4538 3.67201 13.3105 3.81038L6.871 10.2499H4.75V8.12888L11.1895 1.68938Z"
      stroke={props.color || "1175B5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DeleteIcon = (props: Props) => (
  <Icon w="14px" h="16px" viewBox="0 0 14 16" fill="none" {...props}>
    <path
      d="M1 4.25H13M12.25 4.25L11.5997 13.3565C11.5728 13.7349 11.4035 14.0891 11.1258 14.3477C10.8482 14.6063 10.4829 14.75 10.1035 14.75H3.8965C3.5171 14.75 3.1518 14.6063 2.87416 14.3477C2.59653 14.0891 2.42719 13.7349 2.40025 13.3565L1.75 4.25H12.25ZM5.5 7.25V11.75V7.25ZM8.5 7.25V11.75V7.25ZM9.25 4.25V2C9.25 1.80109 9.17098 1.61032 9.03033 1.46967C8.88968 1.32902 8.69891 1.25 8.5 1.25H5.5C5.30109 1.25 5.11032 1.32902 4.96967 1.46967C4.82902 1.61032 4.75 1.80109 4.75 2V4.25H9.25Z"
      stroke={props.color || "#1175B5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalendarIcon = (props: Props) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M6 5V1V5ZM14 5V1V5ZM5 9H15H5ZM3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z"
      stroke={props.color || "#1175B5"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const AlertInfoIcon = (props: Props) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z"
      fill="#0066FF"
    />
  </Icon>
);

export const AlertSuccessIcon = (props: Props) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM11.707 6.707C11.8892 6.5184 11.99 6.2658 11.9877 6.0036C11.9854 5.7414 11.8802 5.49059 11.6948 5.30518C11.5094 5.11977 11.2586 5.0146 10.9964 5.01233C10.7342 5.01005 10.4816 5.11084 10.293 5.293L7 8.586L5.707 7.293C5.5184 7.11084 5.2658 7.01005 5.0036 7.01233C4.7414 7.0146 4.49059 7.11977 4.30518 7.30518C4.11977 7.49059 4.0146 7.7414 4.01233 8.0036C4.01005 8.2658 4.11084 8.5184 4.293 8.707L6.293 10.707C6.48053 10.8945 6.73484 10.9998 7 10.9998C7.26516 10.9998 7.51947 10.8945 7.707 10.707L11.707 6.707Z"
      fill="#4E8A12"
    />
  </Icon>
);

export const AlertWarningIcon = (props: Props) => (
  <Icon w="16px" h="14px" viewBox="0 0 16 14" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83986 1.02C6.60486 -0.34 8.56186 -0.34 9.32586 1.02L14.9059 10.94C15.6559 12.274 14.6929 13.92 13.1639 13.92H2.00286C0.472856 13.92 -0.490144 12.274 0.259856 10.94L5.83986 1.02ZM8.58286 10.921C8.58286 11.1862 8.4775 11.4406 8.28996 11.6281C8.10243 11.8156 7.84807 11.921 7.58286 11.921C7.31764 11.921 7.06329 11.8156 6.87575 11.6281C6.68821 11.4406 6.58286 11.1862 6.58286 10.921C6.58286 10.6558 6.68821 10.4014 6.87575 10.2139C7.06329 10.0264 7.31764 9.921 7.58286 9.921C7.84807 9.921 8.10243 10.0264 8.28996 10.2139C8.4775 10.4014 8.58286 10.6558 8.58286 10.921ZM7.58286 2.921C7.31764 2.921 7.06329 3.02636 6.87575 3.21389C6.68821 3.40143 6.58286 3.65578 6.58286 3.921V6.921C6.58286 7.18622 6.68821 7.44057 6.87575 7.62811C7.06329 7.81564 7.31764 7.921 7.58286 7.921C7.84807 7.921 8.10243 7.81564 8.28996 7.62811C8.4775 7.44057 8.58286 7.18622 8.58286 6.921V3.921C8.58286 3.65578 8.4775 3.40143 8.28996 3.21389C8.10243 3.02636 7.84807 2.921 7.58286 2.921Z"
      fill="#C27A02"
    />
  </Icon>
);

export const ApplicationIcon = (props: Props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H0V18C0 19.11 0.9 20 2 20H16V18H2V4ZM16.5 12.25C16.5 10.75 13.5 10 12 10C10.5 10 7.5 10.75 7.5 12.25V13H16.5M12 8.25C13.24 8.25 14.25 7.24 14.25 6C14.25 4.76 13.24 3.75 12 3.75C10.76 3.75 9.75 4.76 9.75 6C9.75 7.24 10.76 8.25 12 8.25ZM18 0H6C4.9 0 4 0.9 4 2V14C4 15.11 4.9 16 6 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.1 0 18 0ZM18 14H6V2H18V14Z"
      fill="#000"
    />
  </svg>
);

export const AccountIcon = (props: Props) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 24 16"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 8C9.2 8 11 6.2 11 4C11 1.8 9.2 0 7 0C4.8 0 3 1.8 3 4C3 6.2 4.8 8 7 8ZM11 16V10.7C9.9 10.3 8.5 10 7 10C3.1 10 0 11.8 0 14V16H11ZM22 0H15C13.9 0 13 0.9 13 2V14C13 15.1 13.9 16 15 16H22C23.1 16 24 15.1 24 14V2C24 0.9 23.1 0 22 0ZM18 14H16V2H18V14Z"
      fill="#000"
    />
  </svg>
);

export const PaymentIcon = ({ color }: Props) => (
  <svg
    width="20px"
    height="16px"
    viewBox="0 0 22 16"
    fill={color || "#000"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 0H22V12H4V0ZM13 3C13.7956 3 14.5587 3.31607 15.1213 3.87868C15.6839 4.44129 16 5.20435 16 6C16 6.79565 15.6839 7.55871 15.1213 8.12132C14.5587 8.68393 13.7956 9 13 9C12.2044 9 11.4413 8.68393 10.8787 8.12132C10.3161 7.55871 10 6.79565 10 6C10 5.20435 10.3161 4.44129 10.8787 3.87868C11.4413 3.31607 12.2044 3 13 3M8 2C8 2.53043 7.78929 3.03914 7.41421 3.41421C7.03914 3.78929 6.53043 4 6 4V8C6.53043 8 7.03914 8.21071 7.41421 8.58579C7.78929 8.96086 8 9.46957 8 10H18C18 9.46957 18.2107 8.96086 18.5858 8.58579C18.9609 8.21071 19.4696 8 20 8V4C19.4696 4 18.9609 3.78929 18.5858 3.41421C18.2107 3.03914 18 2.53043 18 2H8ZM0 4H2V14H18V16H0V4Z"
      fill={color || "#000"}
    />
  </svg>
);

export const ProductIcon = (props: Props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5M19.41 9.58L10.41 0.58C10.05 0.22 9.55 0 9 0H2C0.89 0 0 0.89 0 2V9C0 9.55 0.22 10.05 0.59 10.41L9.58 19.41C9.95 19.77 10.45 20 11 20C11.55 20 12.05 19.77 12.41 19.41L19.41 12.41C19.78 12.05 20 11.55 20 11C20 10.44 19.77 9.94 19.41 9.58Z"
      fill="#000"
    />
  </svg>
);

export const BusinessIcon = (props: Props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12H14V14H16M16 8H14V10H16M18 16H10V14H12V12H10V10H12V8H10V6H18M8 4H6V2H8M8 8H6V6H8M8 12H6V10H8M8 16H6V14H8M4 4H2V2H4M4 8H2V6H4M4 12H2V10H4M4 16H2V14H4M10 4V0H0V18H20V4H10Z"
      fill="white"
    />
  </svg>
);

export const DashboardIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-layout-dashboard"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    stroke="#000"
    strokeWidth="1.5"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 4h6v8h-6z" />
    <path d="M4 16h6v4h-6z" />
    <path d="M14 12h6v8h-6z" />
    <path d="M14 4h6v4h-6z" />
  </svg>
);

export const UserActive = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-user-check"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    stroke="#000"
    strokeWidth="1.5"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
    <path d="M15 19l2 2l4 -4" />
  </svg>
);

export const UserPending = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-user-exclamation"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    stroke="#000"
    strokeWidth="1.5"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
    <path d="M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.008 .128" />
    <path d="M19 16v3" />
    <path d="M19 22v.01" />
  </svg>
);

export const UserCalendar = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-calendar-user"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="#000"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4.5" />
    <path d="M16 3v4" />
    <path d="M8 3v4" />
    <path d="M4 11h16" />
    <path d="M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2" />
  </svg>
);

export const CashIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-cash"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="#000"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" />
    <path d="M14 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    <path d="M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2" />
  </svg>
);

export const CreditCardPayIcon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-credit-card-pay"
    width="44"
    height="44"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="#000"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5" />
    <path d="M3 10h18" />
    <path d="M16 19h6" />
    <path d="M19 16l3 3l-3 3" />
    <path d="M7.005 15h.005" />
    <path d="M11 15h2" />
  </svg>
);

export const MerchantIcon = (props: Props) => {
  const { color, width, height } = props;
  return (
    <svg
      width={width || "35"}
      height={height || "35"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color || "#080341"}
        d="M4.87617 3.75H19.1238L21 8.86683V10.5C21 11.2516 20.7177 11.9465 20.25 12.4667V21H3.75V12.4667C3.28234 11.9465 3 11.2516 3 10.5V8.86683L4.87617 3.75ZM18.1875 13.3929C18.3807 13.3929 18.5688 13.3731 18.75 13.3355V19.5H15V15H9L9 19.5H5.25V13.3355C5.43122 13.3731 5.61926 13.3929 5.8125 13.3929C6.63629 13.3929 7.36559 13.0334 7.875 12.4667C8.38441 13.0334 9.11371 13.3929 9.9375 13.3929C10.7613 13.3929 11.4906 13.0334 12 12.4667C12.5094 13.0334 13.2387 13.3929 14.0625 13.3929C14.8863 13.3929 15.6156 13.0334 16.125 12.4667C16.6344 13.0334 17.3637 13.3929 18.1875 13.3929ZM10.5 19.5H13.5V16.5H10.5L10.5 19.5ZM19.5 9.75V10.5C19.5 11.2965 18.8856 11.8929 18.1875 11.8929C17.4894 11.8929 16.875 11.2965 16.875 10.5V9.75H19.5ZM19.1762 8.25L18.0762 5.25H5.92383L4.82383 8.25H19.1762ZM4.5 9.75V10.5C4.5 11.2965 5.11439 11.8929 5.8125 11.8929C6.51061 11.8929 7.125 11.2965 7.125 10.5V9.75H4.5ZM8.625 9.75V10.5C8.625 11.2965 9.23939 11.8929 9.9375 11.8929C10.6356 11.8929 11.25 11.2965 11.25 10.5V9.75H8.625ZM12.75 9.75V10.5C12.75 11.2965 13.3644 11.8929 14.0625 11.8929C14.7606 11.8929 15.375 11.2965 15.375 10.5V9.75H12.75Z"
      />
    </svg>
  );
};

export const UserIcon = (props: Props) => {
  const { color, width, height } = props;
  return (
    <svg
      width={width || "35"}
      height={height || "35"}
      viewBox="0 0 24 24"
      fill={"none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 21C5 17.134 8.13401 14 12 14C15.866 14 19 17.134 19 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
        stroke={color || "#000000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadTransactionIcon = (props: Props) => {
  return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        shapeRendering="geometricPrecision" 
        textRendering="geometricPrecision" 
        imageRendering="optimizeQuality" 
        fillRule="evenodd" 
        clipRule="evenodd" 
        viewBox="0 0 441 512.02">
          <path d="M324.87 279.77c32.01 0 61.01 13.01 82.03 34.02 21.09 21 34.1 50.05 34.1 82.1 0 32.06-13.01 61.11-34.02 82.11l-1.32 1.22c-20.92 20.29-49.41 32.8-80.79 32.8-32.06 0-61.1-13.01-82.1-34.02-21.01-21-34.02-50.05-34.02-82.11s13.01-61.1 34.02-82.1c21-21.01 50.04-34.02 82.1-34.02zM243.11 38.08v54.18c.99 12.93 5.5 23.09 13.42 29.85 8.2 7.01 20.46 10.94 36.69 11.23l37.92-.04-88.03-95.22zm91.21 120.49-41.3-.04c-22.49-.35-40.21-6.4-52.9-17.24-13.23-11.31-20.68-27.35-22.19-47.23l-.11-1.74V25.29H62.87c-10.34 0-19.75 4.23-26.55 11.03-6.8 6.8-11.03 16.21-11.03 26.55v336.49c0 10.3 4.25 19.71 11.06 26.52 6.8 6.8 16.22 11.05 26.52 11.05h119.41c2.54 8.79 5.87 17.25 9.92 25.29H62.87c-17.28 0-33.02-7.08-44.41-18.46C7.08 432.37 0 416.64 0 399.36V62.87c0-17.26 7.08-32.98 18.45-44.36C29.89 7.08 45.61 0 62.87 0h173.88c4.11 0 7.76 1.96 10.07 5l109.39 118.34c2.24 2.43 3.34 5.49 3.34 8.55l.03 119.72c-8.18-1.97-16.62-3.25-25.26-3.79v-89.25zm-229.76 54.49c-6.98 0-12.64-5.66-12.64-12.64 0-6.99 5.66-12.65 12.64-12.65h150.49c6.98 0 12.65 5.66 12.65 12.65 0 6.98-5.67 12.64-12.65 12.64H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h142.52c3.71 0 7.05 1.6 9.37 4.15a149.03 149.03 0 0 0-30.54 21.14H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h86.2c-3.82 8.05-6.95 16.51-9.29 25.29h-76.91zm264.81 47.03c3.56-.14 6.09-1.33 7.54-3.55 3.98-5.94-1.44-11.81-5.19-15.94l-40.04-40.71c-4.32-4.26-9.32-4.31-13.64 0l-41.01 41.82c-3.51 3.96-7.86 9.36-4.19 14.83 1.49 2.22 4 3.41 7.56 3.55h19.74v30.69c0 5.84 4.81 10.69 10.7 10.69h28.06c5.9 0 10.71-4.81 10.71-10.69v-30.69h19.76z" />
        </svg>
    );
};

export const CSVFile = (props: Props) => {
  const { color, width, height } = props;
  return (
    <svg fill={color ?? "#000000"} version="1.1" id="Capa_1" 
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "35"}
        height={height ?? "35"}
        viewBox="0 0 548.29 548.291">
      <g>
        <path d="M486.2,196.121h-13.164V132.59c0-0.399-0.064-0.795-0.116-1.2c-0.021-2.52-0.824-5-2.551-6.96L364.656,3.677
          c-0.031-0.034-0.064-0.044-0.085-0.075c-0.629-0.707-1.364-1.292-2.141-1.796c-0.231-0.157-0.462-0.286-0.704-0.419
          c-0.672-0.365-1.386-0.672-2.121-0.893c-0.199-0.052-0.377-0.134-0.576-0.188C358.229,0.118,357.4,0,356.562,0H96.757
          C84.893,0,75.256,9.649,75.256,21.502v174.613H62.093c-16.972,0-30.733,13.756-30.733,30.73v159.81
          c0,16.966,13.761,30.736,30.733,30.736h13.163V526.79c0,11.854,9.637,21.501,21.501,21.501h354.777
          c11.853,0,21.502-9.647,21.502-21.501V417.392H486.2c16.966,0,30.729-13.764,30.729-30.731v-159.81
          C516.93,209.872,503.166,196.121,486.2,196.121z M96.757,21.502h249.053v110.006c0,5.94,4.818,10.751,10.751,10.751h94.973v53.861
          H96.757V21.502z M258.618,313.18c-26.68-9.291-44.063-24.053-44.063-47.389c0-27.404,22.861-48.368,60.733-48.368
          c18.107,0,31.447,3.811,40.968,8.107l-8.09,29.3c-6.43-3.107-17.862-7.632-33.59-7.632c-15.717,0-23.339,7.149-23.339,15.485
          c0,10.247,9.047,14.769,29.78,22.632c28.341,10.479,41.681,25.239,41.681,47.874c0,26.909-20.721,49.786-64.792,49.786
          c-18.338,0-36.449-4.776-45.497-9.77l7.38-30.016c9.772,5.014,24.775,10.006,40.264,10.006c16.671,0,25.488-6.908,25.488-17.396
          C285.536,325.789,277.909,320.078,258.618,313.18z M69.474,302.692c0-54.781,39.074-85.269,87.654-85.269
          c18.822,0,33.113,3.811,39.549,7.149l-7.392,28.816c-7.38-3.084-17.632-5.939-30.491-5.939c-28.822,0-51.206,17.375-51.206,53.099
          c0,32.158,19.051,52.4,51.456,52.4c10.947,0,23.097-2.378,30.241-5.238l5.483,28.346c-6.672,3.34-21.674,6.919-41.208,6.919
          C98.06,382.976,69.474,348.424,69.474,302.692z M451.534,520.962H96.757v-103.57h354.777V520.962z M427.518,380.583h-42.399
          l-51.45-160.536h39.787l19.526,67.894c5.479,19.046,10.479,37.386,14.299,57.397h0.709c4.048-19.298,9.045-38.352,14.526-56.693
          l20.487-68.598h38.599L427.518,380.583z"/>
      </g>
    </svg>
  );
};
